import get from 'lodash/fp/get';
import map from 'lodash/fp/map';

export const getPhoto = get('photos[0].url');
export const transformPhotosToImage = item => ({
  ...item,
  image: getPhoto(item),
});

export const mapPhotos = map(transformPhotosToImage);
